import * as selectors from '../../../core/materials/selectors';
import editMaterial from '../../../core/materials/operations/editMaterial.operation';
import setEditing from '../../../core/materials/operations/setEditing.operation';

const randomKey = () => Math.random().toString(36).substr(2, 5);
const renameKeys = (keysMap, obj) =>
  Object.keys(obj).reduce(
    (acc, key) => ({
      ...acc,
      ...{ [keysMap[key] || key]: obj[key] },
    }),
    {}
  );
const randomizeEntityKeys = (content) => {
  const keyMap = Object.fromEntries(
    new Map(Object.keys(content.entityMap).map((k) => [k, randomKey()]))
  );
  return {
    ...content,
    entityMap: renameKeys(keyMap, content.entityMap),
    blocks: content.blocks.map((b) => ({
      ...b,
      entityRanges: b.entityRanges.map((e) => ({
        ...e,
        key: keyMap[e.key],
      })),
    })),
  };
};

const importMaterialPage = (sectionId, importingContent) => async (
  dispatch,
  getState
) => {
  const state = getState();
  const currentMaterial = selectors.getMaterial(state, sectionId);
  const importingMaterialContent = randomizeEntityKeys(
    importingContent.material[0].content
  );

  const updatedMaterial = {
    ...currentMaterial,
    content: {
      ...currentMaterial.content,
      blocks: [
        ...currentMaterial.content.blocks,
        ...importingMaterialContent.blocks,
      ],
      entityMap: {
        ...currentMaterial.content.entityMap,
        ...importingMaterialContent.entityMap,
      },
    },
  };
  dispatch(editMaterial(updatedMaterial));
  dispatch(setEditing(true));
};

export default importMaterialPage;
